module.exports = __webpack_public_path__ + "img/icon_delete.96f809f8.png";